
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/p/[slug]",
      function () {
        return require("private-next-pages/p/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/p/[slug]"])
      });
    }
  